'use client';

import dynamic from 'next/dynamic';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import HireProcess from '@/components/technologies/hire-process';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import SMMServies from '@/components/technologies/smm-demand';

import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import ContetImageSection from '@/components/common/content-image';
import Blog from '@/components/home/blog';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHeroApp = dynamic(() => import('@/components/technologies/tech-hero-app'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroApp
                className=""
                desc="Let Your Brand Beat The Targets with Our Social Media Marketing Services!"
                alt="hero image"
                title="hero image"
                width={587}
                height={550}
                path={'smm-hero'}
                bgPath={'hero-bg-grunge-orange'}
                color="orange"
                isOrange={true}
            >
                Social Media Marketing Services
            </TechHeroApp>
            <DefaultBreadcrumb parentPage="Services" isParent={true} currentPage="Social Media Marketing Services" />

            <ContetImageSection title="Why Social Media Marketing Service?">
                <>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        Having capabilities to drive more business revenue, Social Media Marketing helps your business generate
                        more leads by attracting visitors and converting them into permanent customers. Its various marketing
                        services like Facebook Ads and Instagram Ads Management not only engage more business to your website but,
                        also scale your business revenue to an unprecedented level. Social Media Marketing service is one of the
                        best choices for the business expects quick results and more ROI than expected
                    </p>
                </>
            </ContetImageSection>

            <SMMServies />

            <HireProcess
                white={true}
                bg="bg-primary"
                pageTitle="Hire SMM Expert To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using Social Media Marketing."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For SMM Services?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best SMM Expert"
                desc="Select from different engagement models to hire SMM experts for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
